<template>
  <div class="swiper-container">
    <swiper
      ref="swiper"
      :options="swiperOption"
      class="m-topic-swiper"
      style="transition-duration: 0ms; transform: translate3d(0px, 0px, 0px);"
    >
      <swiperSlide style="height: 50vh;">
        <div class="conference-index">
          <div class="main-content">
            <div class="video-container">
              <video
                class="gvideo"
                autoplay
                loop
                preload="auto"
                muted
                poster="@/assets/developerConference/index-banner.jpg"
              >
                <source
                  src="https://www.dev.hs.net/r/cms/www/itn/images/0901.mp4"
                />
                Your browser does not support the video tag. I suggest you
                upgrade your browser.
              </video>
            </div>

            <div class="ecological-partner" v-if="!localTimeOver">
              <img
                src="@/assets/developerConference/title-animation.gif"
                alt="title"
              />
              <img
                src="@/assets/developerConference/address-desc.png"
                alt="address-time"
              />
              <CountDown :time="timestamp" :isMiniSecond="true" />
              <div class="hover-box">
                <img
                  class="hover-jump"
                  @click="jumpDetail('joinActive')"
                  src="@/assets/developerConference/home-joinNow.png"
                />
              </div>
            </div>
            <img
              class="ecological-partner-end"
              src="@/assets/developerConference/live-end-img.png"
              v-else
            />
          </div>
          <!-- 跳动箭头 -->
          <div class="up-down-arrow">
            <img src="@/assets/developerConference/up-down-arrow.png" alt="" />
            <div class="desctext">下滑进入云会场</div>
          </div>
        </div>
      </swiperSlide>
      <swiperSlide>
        <CloudMeeting @jumpDetail="jumpDetail" />
      </swiperSlide>
    </swiper>
  </div>
</template>
<script>
import store from "@/store";
import axios from "axios";
import _ from "lodash";
import CountDown from "./components/countDown.vue";
import CloudMeeting from "./cloudMeeting";
import { Swiper, swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import { mapGetters, mapActions } from "vuex";
import {
  checkLogin,
  get_signup_end_time,
  checkOnlineSignup
} from "@/api/developerConference.js";

export default {
  data() {
    return {
      // 倒计时间隔时间戳
      timestamp: "-1",
      swiperOption: {
        //slidesPerView: 4,
        spaceBetween: 30,
        //loop: true,
        //loopFillGroupWithBlank: true,
        notNextTick: true,
        // swiper configs 所有的配置同swiper官方api配置
        // effect: "fade",
        // fadeEffect: {
        //   crossFade: true
        // },
        direction: "vertical",
        grabCursor: true,
        setWrapperSize: true,
        autoHeight: true,
        mousewheelControl: true,
        observeParents: true,
        shortSwipes: true,
        autoplayDisableOnInteraction: false,
        paginationClickable: true,
        followFinger: false,
        speed: 500,
        nextButton: ".up-down-arrow"
      }
    };
  },

  components: {
    CountDown,
    CloudMeeting,
    swiper,
    swiperSlide
  },

  computed: {
    ...mapGetters(["user"]),
    // 修改首页中倒计时和报名按钮的显示判定条件，将后端的difftime和0比较作为判定条件，小于0则显示海报，大于0则有倒计时和报名按钮
    localTimeOver() {
      return this.timestamp >= 0 ? false : true;
    }
  },

  mounted() {
    this.updateTimeStamp();
    // 因为切屏后会对计时器造成影响，所以增加一个对可见性的事件监听，及时更新定时器的时间
    const that = this;
    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState == "visible") {
        that.updateTimeStamp();
      }
    });
  },
  beforeDestroy() {
    document.removeEventListener("visibilitychange", () => {});
  },

  methods: {
    ...mapActions(["timeover"]),

    // 更新时间戳,如果已经超时就不用再次发起请求更新时间戳，如果未超时，则每次更新页面都更新时间戳
    async updateTimeStamp() {
      get_signup_end_time().then(res => {
        if (res) {
          this.timestamp = res.diff_time;
          this.timeover({ diffTime: res.diff_time });
        }
      });
    },
    // 报名or其他
    jumpDetail(a) {
      if (a === "joinActive") {
        this.gotoJoinTab();
      }
    },

    gotoJoinTab() {
      checkLogin().then(res1 => {
        if (res1) {
          checkOnlineSignup().then(res2 => {
            // 没报名
            if (res2 === null || res2.data === null) {
              let hsid = this.$store.getters.hsid||'-';
              this.$router.push({ path: "/developerConference/ticketing" });
              this.gioTrackEvent("LDC_loginUserApplyClick", {
                pageName_var: "首页",
                hsUserId_var: hsid,
                deviceType_var: "Web"
              });
            }
            // 已报名
            else {
              this.$hMessage.info("您已成功报名，无须重复报名。");
            }
          });
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.swiper-container {
  height: 100vh;
}
.conference-index {
  .main-content {
    width: 100%;
    min-width: 1200px;
    background: url("../../../assets/developerConference/index-banner.jpg")
      no-repeat center;
    background-size: 100% 100%;
    position: relative;
    // margin-top: 20px;
    .video-container {
      position: fixed;
      height: 100%;
      width: 100%;
      overflow: hidden;
      z-index: -100;
    }
    .video-container:before {
      content: "";
      position: absolute;
      width: 100%;
      height: 100%;
      display: block;
      z-index: -1;
      top: 0;
      left: 0;
    }
    .gvideo {
      position: absolute;
      display: block;
      width: 100%;
      z-index: -100;
    }
    img {
      width: 100%;
    }
    .ecological-partner {
      min-height: 300px;
      width: 500px;
      height: 500px;
      position: absolute;
      left: 50%;
      transform: translateX(-50%) translateY(20%);
      margin: auto;
      text-align: center;
      img {
        width: 100%;
      }
      img:nth-child(1) {
        height: 40%;
      }
      img:nth-child(2) {
        position: absolute;
        top: 38%;
        left: 50%;
        width: 135%;
        transform: translateX(-50%);
        height: 21%;
      }
      .hover-box {
        opacity: 1;
        position: absolute;
        top: 87%;
      }
      .countdowm {
        position: absolute;
        top: 61%;
        left: 50%;
        width: 100%;
        transform: translateX(-50%);
        display: flex;
      }
    }
    .ecological-partner-end {
      min-height: 500px;
      width: 800px;
      height: 500px;
      position: absolute;
      object-fit: contain;
      left: 50%;
      transform: translateX(-50%) translateY(25%);
      margin: auto;
      text-align: center;
    }

    @media (max-width: 1366px), (max-height: 600px) {
      .ecological-partner {
        width: 350px;
        height: 350px;
        transform: translateX(-50%) translateY(30%);
      }
      .ecological-partner-end {
        width: 450px;
        height: 500px;
        object-fit: contain;
        transform: translateX(-50%) translateY(5%);
      }
    }

    .hover-box {
      width: 55%;
      min-width: 120px;
      max-height: 58px;
      position: absolute;
      top: 63%;
      left: 50%;
      transform: translate(-50%);
      background-size: 100% 100%;
      cursor: auto;
      border-radius: 2px;

      .hover-jump {
        // background: url("../../../assets/developerConference/joinNow.png");
        background-size: cover;
        border-radius: 2px;
        cursor: pointer;
      }
    }
  }
  .up-down-arrow {
    position: absolute;
    cursor: pointer;
    left: 50%;
    min-width: 220px;
    transform: translateX(-50%);
    text-align: center;
    top: 86%;
    & img {
      position: absolute;
      transform: translateX(-50%);
      left: 50%;
      width: 40px;
      height: 45px;
      animation-duration: 1s;
      animation-name: updownarrow;
      animation-iteration-count: infinite;
      animation-direction: alternate;
    }
    @keyframes updownarrow {
      from {
        top: 0%;
      }
      50% {
        top: 10%;
      }
      to {
        top: 20%;
      }
    }
    .desctext {
      margin-top: 70px;
      font-size: 16px;
      color: #333333;
    }
  }
  @media (max-width: 1366px) {
    .up-down-arrow {
      img {
        width: 30px;
        height: 32px;
      }
      .desctext {
        margin-top: 50px;
      }
    }
  }
  @media (max-width: 1200px) {
    .up-down-arrow {
      left: 600px;
      transform: translateX(-50%);
    }
  }
}
</style>
<style lang="scss">
.conference-index .h-form .h-form-item {
  margin-bottom: 16px;
}
.conference-index .h-form .h-form-item-label {
  font-size: 14px;
  color: #333333;
  padding: 0;
  &:after {
    display: inline-block;
    content: "*";
    font-family: MicrosoftYaHei;
    font-size: 14px;
    color: #ff1f77;
    letter-spacing: 0.92px;
    margin-left: 4px;
  }
}
.conference-index .h-input-wrapper .h-input {
  height: 32px;
}
.conference-index .h-select-single .h-select-selection {
  height: 36px;
}
.page-header-banner {
  background-size: contain;
}
// 媒体查询
</style>



// WEBPACK FOOTER //
// src/gtn/views/frontViews/developerConference/conferenceIndex.vue